import React, { useEffect, useMemo, useState } from "react";
import {
    Card,
    CardBody,
    Row,
    Col,
    Label,
    Input,
    Button,
    Table,
} from "reactstrap";

import swal from "sweetalert";
import axiosConfig from "../../AxiosConfig";

export default function StockTransfer() {
    const [productSections, setProductSections] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [stockTransferList, setStockTransferList] =
        useState([]);
    const [allProducts, setAllProducts] = useState([]);

    const [formData, setFormData] = useState({
        fromWarehouse: "",
        toWarehouse: "",

        product: [],
        qty: "",
        landedCost: "",
        remark: "",

        fromProductSection: "",
        toProductSection: "",

        transferProduct: "",
        transferQty: "",
        transferRemark: "",
    });

    // ================= FETCH WAREHOUSE =================

    const fetchWarehouses = async () => {
        try {

            const userData = JSON.parse(
                localStorage.getItem("userData")
            );

            const res = await axiosConfig.get(
                `/warehouse/view-warehouse/${userData?.database}`
            );
            setWarehouseList(
                res?.data?.Warehouse || []
            );
        } catch (err) {
            console.log(err);
        }
    };

    const fetchProductSections = async () => {
        try {
            const userData = JSON.parse(
                localStorage.getItem("userData")
            );

            const db = userData?.database;

            const res = await axiosConfig.get(
                `/product-type/view-producttype/${db}`
            );

            console.log("PRODUCT SECTION", res);
            setProductSections(
                res?.data?.productType || []
            );
        } catch (error) {
            console.log(error);
        }
    };
    const fetchStockTransferList = async () => {

        try {

            const userData = JSON.parse(
                localStorage.getItem("userData")
            );
            const currentDate = new Date();

            const currentYear =
                currentDate.getFullYear();

            const nextYear =
                currentYear + 1;

            const month =
                currentDate.getMonth() + 1;

            const financialYear =
                month >= 4
                    ? `${currentYear}-${nextYear}`
                    : `${currentYear - 1}-${currentYear}`;

            const res = await axiosConfig.get(
                `/stock-updation/view-stock-transfer/${userData?.database}/${financialYear}`
            );
            console.log(
                "STOCK TRANSFER LIST =>",
                res?.data
            );

            setStockTransferList(
                res?.data?.Warehouse || []
            );

        } catch (err) {

            console.log(err);
        }
    };


    // ================= FETCH PRODUCTS =================

    const fetchProducts = async () => {
        try {

            const userData = JSON.parse(
                localStorage.getItem("userData")
            );

            const res = await axiosConfig.get(
                `/product/view-product-purchase/${userData?.database}`
            );
            setAllProducts(
                res?.data?.Product || []
            );

        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchWarehouses();
        fetchProducts();
        fetchStockTransferList();
        fetchProductSections();
    }, []);

    // ================= FIND SELECTED WAREHOUSE =================

    // ================= FIND SELECTED WAREHOUSE =================

    const selectedFromWarehouse = warehouseList.find(
        (w) => w._id === formData.fromWarehouse
    );

const fromProductSectionOptions = useMemo(() => {
    if (!selectedFromWarehouse) return [];

    const sections = selectedFromWarehouse.productItems
        ?.map((item) => item?.productId?.productSection)
        .filter(Boolean) || [];

    return [...new Set(sections)];
}, [selectedFromWarehouse]);

    // ================= TO WAREHOUSE FILTER =================

    const filteredToWarehouses = useMemo(() => {
        return warehouseList.filter(
            (w) => w._id !== formData.fromWarehouse
        );
    }, [warehouseList, formData.fromWarehouse]);

    // ================= SELECTED TO WAREHOUSE =================

    const selectedToWarehouse = warehouseList.find(
        (w) => w._id === formData.toWarehouse
    );

const toProductSectionOptions = useMemo(() => {
    if (!selectedToWarehouse) return [];

    const sections = selectedToWarehouse.productItems
        ?.map((item) => item?.productId?.productSection)
        .filter(Boolean) || [];

    return [...new Set(sections)];
}, [selectedToWarehouse]);

    // ================= SALES PRODUCT FILTER =================



  
const filteredSalesProducts = useMemo(() => {
    if (!selectedFromWarehouse) return [];

    const items = selectedFromWarehouse.productItems || [];

    const warehouseType = String(
        selectedFromWarehouse.warehouseType || ""
    ).trim().toLowerCase();

    return items.filter((item) => {
        const product = item?.productId;

        if (!product || typeof product !== "object") {
            return false;
        }

        const productType = String(product.type || "")
            .trim()
            .toLowerCase();

        if (warehouseType === "trading") {
            return productType === "trading";
        }

        if (warehouseType === "production") {
            return productType === "production";
        }

        return true;
    });
}, [selectedFromWarehouse]);



    console.log(
        "WAREHOUSE PRODUCT ITEMS =>",
        selectedFromWarehouse?.productItems
    );

    console.log(
        "FIRST WAREHOUSE ITEM =>",
        selectedFromWarehouse?.productItems?.[0]
    );

    console.log(
        "FIRST PRODUCT DATA =>",
        selectedFromWarehouse?.productItems?.[0]?.productId
    );

    console.log(
        "ALL PRODUCT API DATA =>",
        allProducts
    );


    // ================= SALES PRODUCT SECTION FILTER =================


  const filteredSalesProductsBySection = useMemo(() => {
  const selectedSection = String(
    formData.fromProductSection || ""
  ).trim().toLowerCase();

  const items = selectedFromWarehouse?.productItems || [];

  if (!selectedSection) return [];

  return items.filter((item) => {
    const product = item?.productId;

    if (!product || typeof product !== "object") return false;

    const type = String(product.type || "").trim().toLowerCase();
    const section = String(product.productSection || "")
      .trim()
      .toLowerCase();

    // Trading
    if (selectedSection === "trading") {
      return type === "trading";
    }

    // Production section
    if (selectedSection === "production") {
      return section === "production";
    }

    // Final Product section
    if (selectedSection === "final product") {
      return section === "final product";
    }

    return false;
  });
}, [selectedFromWarehouse, formData.fromProductSection]);

    // ================= TRANSFER PRODUCT FILTER =================

   const filteredTransferProducts = useMemo(() => {
    if (!selectedToWarehouse) return [];

    const items = selectedToWarehouse.productItems || [];

    const warehouseType = String(
        selectedToWarehouse.warehouseType || ""
    ).trim().toLowerCase();

    return items.filter((item) => {
        const product = item?.productId;

        if (!product || typeof product !== "object") {
            return false;
        }

        const productType = String(product.type || "")
            .trim().toLowerCase();

        if (warehouseType === "trading") {
            return productType === "trading";
        }

        if (warehouseType === "production") {
            return productType === "production";
        }

        return true;
    });
}, [selectedToWarehouse]);

    // ================= TRANSFER PRODUCT SECTION FILTER =================

 const filteredTransferProductsBySection = useMemo(() => {
  const selectedSection = String(
    formData.toProductSection || ""
  ).trim().toLowerCase();

  const items = selectedToWarehouse?.productItems || [];

  if (!selectedSection) return [];

  return items.filter((item) => {
    const product = item?.productId;

    if (!product || typeof product !== "object") return false;

    const type = String(product.type || "").trim().toLowerCase();
    const section = String(product.productSection || "")
      .trim()
      .toLowerCase();

    if (selectedSection === "trading") {
      return type === "trading";
    }

    if (selectedSection === "production") {
      return section === "production";
    }

    if (selectedSection === "final product") {
      return section === "final product";
    }

    return false;
  });
}, [selectedToWarehouse, formData.toProductSection]);

    // ================= HANDLE CHANGE =================

    const handleChange = (field, value) => {

        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));

    };
    const handleDelete = async (id) => {

        try {

            const res = await axiosConfig.delete(
                `/stock-updation/delete-stock-transfer/${id}`
            );

            if (res?.status === 200 || res?.data?.status) {

                // ✅ direct state update
                setStockTransferList((prev) =>
                    prev.filter(
                        (item) => item._id !== id
                    )
                );

                swal(
                    "Success",
                    "Stock Transfer Deleted Successfully",
                    "success"
                );
            }

        } catch (err) {

            console.log(err);

            swal(
                "Error",
                err?.response?.data?.message ||
                "Delete Failed",
                "error"
            );
        }
    };
    // ================= SUBMIT =================

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (
            !formData.fromWarehouse ||
            !formData.toWarehouse ||
            !formData.product ||
            !formData.transferProduct ||

            !formData.transferQty
        ) {

            swal(
                "Please fill all required fields"
            );

            return;
        }

        try {

            const userData = JSON.parse(
                localStorage.getItem("userData")
            );
            const currentDate = new Date();

            const currentYear =
                currentDate.getFullYear();

            const nextYear =
                currentYear + 1;

            const month =
                currentDate.getMonth() + 1;

            // ✅ April se financial year start
            const financialYear =
                month >= 4
                    ? `${currentYear}-${nextYear}`
                    : `${currentYear - 1}-${currentYear}`;

            console.log(financialYear);

            const payload = {
                warehouseFromId: formData.fromWarehouse,

                warehouseToId: formData.toWarehouse,

                productItems: [
                    {
                        fromProductId: formData.product,

                        toProductId:
                            formData.transferProduct,

                        transferQty: Number(
                            formData.transferQty
                        ),
                        stockTransferPrice: Number(formData.landedCost),
                        totalPrice:
                            Number(formData.transferQty) *
                            Number(selectedSalesProduct?.price || 0),

                        price: Number(
                            selectedSalesProduct
                                ?.price || 0
                        ),

                        primaryUnit:
                            selectedSalesProduct
                                ?.primaryUnit,
                    },
                ],

                stockTransferDate:
                    new Date().toISOString().split("T")[0],
                stockTransferTime:
                    new Date().toLocaleTimeString(),
                database: userData?.database,
                financeYear: financialYear,
                created_by: userData?._id,
            };
            console.log(
                "DIRECT PAYLOAD =>",
                payload
            );
            const res = await axiosConfig.post(
                "/stock-updation/stock-transfer-warehouse",
                payload
            );

            console.log(
                "TRANSFER RESPONSE =>",
                res?.data
            );

            if (
                res?.status === 200 ||
                res?.data?.status
            ) {

                swal(
                    "Success",
                    "Stock Transferred Successfully",
                    "success"
                ).then(() => {

                    // ✅ TABLE REFRESH
                    fetchWarehouses();
                    fetchStockTransferList();

                });

                // ✅ RESET FORM

                setFormData({

                    fromWarehouse: "",
                    toWarehouse: "",

                    product: "",
                    qty: "",
                    remark: "",
                    landedCost: "",

                    transferProduct: "",
                    transferQty: "",
                    transferRemark: "",

                });

            }

        }
        catch (err) {

            console.log("FULL ERROR =>", err);

            console.log(
                "ERROR RESPONSE =>",
                err?.response
            );

            console.log(
                "ERROR DATA =>",
                err?.response?.data
            );

            console.log(
                "ERROR MESSAGE =>",
                err?.response?.data?.message
            );

            swal(
                "Error",
                err?.response?.data?.message ||
                "Something went wrong",
                "error"
            );
        }

    };
    const selectedSalesProduct =
        filteredSalesProductsBySection.find(
            (p) => p?.productId?._id === formData.product
        );
    const availableQty =
        selectedSalesProduct?.productId?.qty || 0;
  
    return (

        <><div className="erp-page-grid">

            <Card className="erp-card">

                <CardBody>

                    <h3
                        style={{
                            marginBottom: "20px",
                        }}
                    >
                        Stock Transfer
                    </h3>

                    <form
                        onSubmit={handleSubmit}
                    >

                        {/* ================= FIRST ROW ================= */}

                        <Row>

                            {/* FROM WAREHOUSE */}

                            <Col md="2">

                                <Label>
                                    From Warehouse
                                </Label>

                                <Input
                                    type="select"
                                    value={formData.fromWarehouse}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            fromWarehouse: e.target.value,
                                            toWarehouse: "",
                                            fromProductSection: "",
                                            toProductSection: "",
                                            product: "",
                                            transferProduct: "",
                                            qty: "",
                                            transferQty: "",
                                            landedCost: "",
                                        })
                                    }
                                >

                                    <option value="">
                                        Select Warehouse
                                    </option>

                                    {warehouseList.map(
                                        (item) => (
                                            <option
                                                key={item._id}
                                                value={item._id}
                                            >
                                                {item.warehouseName}
                                            </option>
                                        )
                                    )}

                                </Input>

                            </Col>

                           
<Col md="2">
  <Label>Product Section</Label>
  <Input
    type="select"
    value={formData.fromProductSection}
    disabled={!selectedFromWarehouse}
    onChange={(e) =>
      setFormData((prev) => ({
        ...prev,
        fromProductSection: e.target.value,
        product: "",
        qty: "",
        transferQty: "",
        landedCost: "",
      }))
    }
  >
    <option value="">Select Product Section</option>
    <option value="Trading">Trading</option>
    <option value="Production">Production</option>
    <option value="Final Product">Final Product</option>
  </Input>
</Col>


                            {/* SALES PRODUCT */}

                            <Col md="2">

                                <Label>
                                    Sales Product
                                </Label>

                                <Input
                                    type="select"
                                    value={formData.product}
                                    onChange={(e) => {

                                        const selectedProduct =
                                            filteredSalesProductsBySection.find(
                                                (p) => p?.productId?._id === e.target.value
                                            );

                                        setFormData({
                                            ...formData,

                                            product: e.target.value,

                                            qty: "",

                                            transferQty: "",

                                            // ✅ price set
                                            landedCost:
                                                selectedProduct?.price || "",
                                        });
                                    }}
                                >

                                    <option value="">
                                        Select Product
                                    </option>

                                    {filteredSalesProductsBySection.map(
                                        (item) => (
                                            <option
                                                key={item?._id}
                                                value={item?.productId?._id}
                                            >
                                                {item?.productId?.Product_Title}
                                            </option>
                                        )
                                    )}

                                </Input>

                            </Col>


                            {/* SALES QTY */}
                            <Col md="2">

                                <Label>
                                    Qty
                                </Label>

                                <Input
                                    type="number"

                                    value={formData.qty}

                                    min="1"

                                    max={availableQty}

                                    onChange={(e) => {

                                        const value = Number(
                                            e.target.value
                                        );

                                        if (value > availableQty) {

                                            swal(
                                                "Stock Limit Exceeded",
                                                `Only ${availableQty} qty available`,
                                                "warning"
                                            );

                                            return;
                                        }

                                        handleChange(
                                            "qty",
                                            e.target.value
                                        );

                                        // auto set transfer qty
                                        handleChange(
                                            "transferQty",
                                            e.target.value
                                        );
                                    }} />

                                {/* AVAILABLE STOCK SHOW */}

                                <small
                                    style={{
                                        color: "green",
                                        fontWeight: "600",
                                    }}
                                >
                                    Available Qty :
                                    {" "}
                                    {availableQty}
                                </small>

                            </Col>

                            <Col md="2">

                                <Label>
                                    Stock Transfer Price
                                </Label>

                                <Input
                                    value={formData.landedCost}
                                    onChange={(e) => handleChange(
                                        "landedCost",
                                        e.target.value
                                    )} />

                            </Col>

                            {/* REMARK */}

                            <Col md="2">

                                <Label>
                                    Remark
                                </Label>

                                <Input
                                    value={formData.remark}
                                    onChange={(e) => handleChange(
                                        "remark",
                                        e.target.value
                                    )} />

                            </Col>

                        </Row>

                        {/* ================= SECOND ROW ================= */}

                        <Row className="mt-2">

                            {/* TO WAREHOUSE */}

                            <Col md="2">

                                <Label>
                                    To Warehouse
                                </Label>

                                <Input
                                    type="select"
                                    value={formData.toWarehouse}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            toWarehouse: e.target.value,
                                            toProductSection: "",
                                            transferProduct: "",
                                        })
                                    }
                                >

                                    <option value="">
                                        Select Warehouse
                                    </option>

                                    {filteredToWarehouses.map(
                                        (item) => (
                                            <option
                                                key={item._id}
                                                value={item._id}
                                            >
                                                {item.warehouseName}
                                            </option>
                                        )
                                    )}

                                </Input>

                            </Col>

                           
<Col md="2">
  <Label>Product Section</Label>
  <Input
    type="select"
    value={formData.toProductSection}
    disabled={!selectedToWarehouse}
    onChange={(e) =>
      setFormData((prev) => ({
        ...prev,
        toProductSection: e.target.value,
        transferProduct: "",
      }))
    }
  >
    <option value="">Select Product Section</option>
    <option value="Trading">Trading</option>
    <option value="Production">Production</option>
    <option value="Final Product">Final Product</option>
  </Input>
</Col>


                            {/* TRANSFER PRODUCT */}

                            <Col md="2">

                                <Label>
                                    Transfer Product
                                </Label>

                                <Input
                                    type="select"
                                    value={formData.transferProduct}
                                    onChange={(e) => handleChange(
                                        "transferProduct",
                                        e.target.value
                                    )}
                                >

                                    <option value="">
                                        Select Product
                                    </option>

                                    {filteredTransferProductsBySection.map(
                                        (item) => (
                                            <option
                                                key={item?._id}
                                                value={item?.productId?._id}
                                            >
                                                {item?.productId?.Product_Title}
                                            </option>
                                        )
                                    )}
                                </Input>

                            </Col>

                            {/* TRANSFER QTY */}

                            <Col md="2">

                                <Label>
                                    Transfer Qty
                                </Label>

                                <Input
                                    type="number"

                                    value={formData.transferQty}

                                    min="1"

                                    max={availableQty}

                                    onChange={(e) => {

                                        const value = Number(
                                            e.target.value
                                        );

                                        if (value > availableQty) {

                                            swal(
                                                "Stock Limit Exceeded",
                                                `Only ${availableQty} qty available`,
                                                "warning"
                                            );

                                            return;
                                        }

                                        handleChange(
                                            "transferQty",
                                            e.target.value
                                        );
                                    }} />

                            </Col>

                            {/* TRANSFER REMARK */}

                            <Col md="3">

                                <Label>
                                    Transfer Remark
                                </Label>

                                <Input
                                    value={formData.transferRemark}
                                    onChange={(e) => handleChange(
                                        "transferRemark",
                                        e.target.value
                                    )} />

                            </Col>

                        </Row>

                        {/* ================= BUTTON ================= */}

                        <Button
                            color="primary"
                            type="submit"
                            style={{
                                marginTop: "25px",
                            }}
                        >
                            Transfer Stock
                        </Button>

                    </form>

                    {/* ================= TABLE ================= */}

                    <div
                        style={{
                            marginTop: "40px",
                        }}
                    >

                        <h4>
                            Stock Transfer History
                        </h4>

                        <Table
                            bordered
                            responsive
                        >

                            <thead style={{ textAlign: "center" }}>

                                <tr>

                                    <th>Date</th>

                                    <th>Time</th>

                                    <th>From Warehouse</th>

                                    <th>To Warehouse</th>

                                    <th>From Product</th>

                                    <th>To Product</th>

                                    <th>Qty</th>

                                    <th>Basic Price</th>

                                    <th>Total</th>
                                    <th>Action</th>

                                </tr>

                            </thead>

                            <tbody style={{ textAlign: "center" }}>
                                {stockTransferList?.map((item, index) =>

                                    item?.productItems?.map((product, i) => (

                                        <tr key={`${index}-${i}`}>

                                            {/* DATE */}
                                            <td>
                                                {item?.stockTransferDate}
                                            </td>

                                            {/* TIME */}
                                            <td>
                                                {item?.stockTransferTime}
                                            </td>

                                            {/* FROM WAREHOUSE */}
                                            <td>
                                                {
                                                    item?.warehouseFromId
                                                        ?.warehouseName
                                                }
                                            </td>

                                            {/* TO WAREHOUSE */}
                                            <td>
                                                {
                                                    item?.warehouseToId
                                                        ?.warehouseName
                                                }
                                            </td>

                                            {/* FROM PRODUCT */}
                                            <td>
                                                {
                                                    product?.fromProductId
                                                        ?.Product_Title
                                                }
                                            </td>

                                            {/* TO PRODUCT */}
                                            <td>
                                                {
                                                    product?.toProductId
                                                        ?.Product_Title
                                                }
                                            </td>

                                            {/* QTY */}
                                            <td>
                                                {product?.transferQty}
                                            </td>

                                            {/* BASIC PRICE */}
                                            <td>
                                                {product?.price}
                                            </td>

                                            {/* TOTAL */}
                                            <td>
                                                {product?.totalPrice}
                                            </td>
                                            <td>

                                                <Button
                                                    color="danger"
                                                    size="sm"
                                                    onClick={() => {

                                                        swal({
                                                            title: "Are you sure?",
                                                            text: "Once deleted, you will not recover this stock transfer!",
                                                            icon: "warning",
                                                            buttons: true,
                                                            dangerMode: true,
                                                        }).then((willDelete) => {

                                                            if (willDelete) {

                                                                handleDelete(item?._id);
                                                            }
                                                        });
                                                    }}
                                                >
                                                    Delete
                                                </Button>

                                            </td>
                                        </tr>

                                    ))
                                )}
                            </tbody>

                        </Table>

                    </div>

                </CardBody>

            </Card>

        </div>

        </>
    );

}